export enum PropertyInfoAreas {
	BasicInfo = "BasicInfo",
	Grouping = "Grouping",
	Render = "Render",
	Change = "Change",
	Validation = "Validation",
	Filter = "Filter"
}